import React from 'react';
import Icon from '../../../components/AppIcon';

const UploadMethodSelector = ({ activeMethod, onMethodChange }) => {
  return (
    <div className="flex gap-3 mb-6">
      <button
        onClick={() => onMethodChange('csv')}
        className={`flex-1 flex items-center gap-3 p-4 rounded-xl border-2 transition-all ${
          activeMethod === 'csv' ?'border-cyan-400 bg-cyan-400/10' :'border-white/10 bg-white/5 hover:border-white/20'
        }`}
      >
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
          activeMethod === 'csv' ? 'bg-cyan-400/20' : 'bg-white/10'
        }`}>
          <Icon name="FileSpreadsheet" size={20} color={activeMethod === 'csv' ? '#00D4FF' : '#94A3B8'} />
        </div>
        <div className="text-left">
          <p className={`font-semibold text-sm ${activeMethod === 'csv' ? 'text-cyan-400' : 'text-white'}`}>CSV Import</p>
          <p className="text-xs text-slate-400">Upload multiple properties at once</p>
        </div>
        {activeMethod === 'csv' && (
          <div className="ml-auto w-5 h-5 rounded-full bg-cyan-400 flex items-center justify-center">
            <Icon name="Check" size={12} color="#050A14" />
          </div>
        )}
      </button>

      <button
        onClick={() => onMethodChange('batch')}
        className={`flex-1 flex items-center gap-3 p-4 rounded-xl border-2 transition-all ${
          activeMethod === 'batch' ?'border-purple-400 bg-purple-400/10' :'border-white/10 bg-white/5 hover:border-white/20'
        }`}
      >
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
          activeMethod === 'batch' ? 'bg-purple-400/20' : 'bg-white/10'
        }`}>
          <Icon name="LayoutList" size={20} color={activeMethod === 'batch' ? '#A78BFA' : '#94A3B8'} />
        </div>
        <div className="text-left">
          <p className={`font-semibold text-sm ${activeMethod === 'batch' ? 'text-purple-400' : 'text-white'}`}>Batch Form</p>
          <p className="text-xs text-slate-400">Add properties one by one</p>
        </div>
        {activeMethod === 'batch' && (
          <div className="ml-auto w-5 h-5 rounded-full bg-purple-400 flex items-center justify-center">
            <Icon name="Check" size={12} color="#050A14" />
          </div>
        )}
      </button>
    </div>
  );
};

export default UploadMethodSelector;
